export default function Tabs({ tabs, activeSubmenu, setActiveSubmenu }) {
  return (
    <nav className="bg-gray-200">
      <ul className="flex h-full w-full gap-x-24 items-center overflow-x-auto">
        {tabs &&
          tabs.length > 0 &&
          tabs.map((tab, index) => (
            <li
              key={index}
              className={`tab-item flex items-center relative h-full py-9 ${
                activeSubmenu === tab.area ? "active-tab-item" : ""
              } duration-300`}
            >
              <span
                className="block whitespace-nowrap rounded-xxxs py-6 text-12 font-medium uppercase text-gray-600 duration-300"
                onClick={() => setActiveSubmenu(tab.area)}
              >
                {tab.area}
              </span>
            </li>
          ))}
      </ul>
    </nav>
  );
}
